import axios from 'axios';

const api = axios.create({
    baseURL:"https://mailsendforintegro.vercel.app/",
    headers:{
        "Content-Type":"application/json",
        Accept:"application/json"
    },
})

export const sendmail = (data) => api.post('/sendmail',data)